import React, { useEffect, useMemo, useState } from 'react';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import { Box, Paper } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DraftsIcon from '@mui/icons-material/Drafts';
import dayjs from 'dayjs';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers } from '../../Interface';
import { DatagridPremiumUi } from '../../Interface';
import useUsers from '../../../context/UsersContext';
import alertMessageService from '../../../service/Alert/alertMessage.service';

const AlertMessagesTable = (props) => {
  const { rowSelection, selectedValuesState, refetchState } = props;
  const apiRef = useGridApiRef();
  const { getUser, user } = useUsers();
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const { setSelectedValues } = selectedValuesState;
  const { refetchTable, setRefetchTable } = refetchState;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'id', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
  }, []);

  const getList = (gridState) => {
    alertMessageService.getMessages(gridState, user.userId).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(
    () => () =>
      dataGridPremiumColumns([
        {
          field: 'alertName',
          headerName: 'Tárgy',
          type: 'string',
          sortable: false,
          filterable: false,
          renderCell: (data) => data.row.alert.name ?? '',
        },
        {
          field: 'createdAt',
          headerName: 'Dátum',
          type: 'date',
          valueGetter: (_data, row) => {
            return new Date(row.createdAt);
          },
          renderCell: (data) => {
            return dayjs(data.row.createdAt).format('YYYY.MM.DD HH:mm');
          },
        },
        {
          field: 'isRead',
          headerName: 'Olvasott',
          type: 'boolean',
          valueGetter: (_data, row) => {
            return Boolean(row.recipients[0].readAt);
          },
          renderCell: (data) => {
            const isRead = Boolean(data?.row?.recipients?.[0]?.readAt);
            return isRead ? (
              <DraftsIcon color="action" fontSize="small" />
            ) : (
              <MailOutlineIcon color="action" fontSize="small" />
            );
          },
        },
      ]),
    []
  );

  return (
    <Box sx={{ overflowX: 'auto' }} pt={1}>
      <Paper
        elevation={1}
        sx={{
          overflow: 'hidden',
          borderRadius: { xs: 1, sm: 2 },
        }}
      >
        <DatagridPremiumUi
          apiRef={apiRef}
          datagridIdentifier={DataGridIdentifiers.AlertMessage}
          height={580}
          columns={columns()}
          onCellDoubleClick={(_params, event) => {
            event.defaultMuiPrevented = true;
          }}
          getRowHeight={() => 'auto'}
          datagridInitialState={initialState}
          dataLoader={getList}
          rows={reports.rows}
          refetch={{ refetchTable, setRefetchTable }}
          rowCount={reports.rowCount}
          onRowClick={(rowData) => {
            setSelectedValues(rowData.row);
          }}
          paginationAndfilterMode="server"
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
        />
      </Paper>
    </Box>
  );
};

export default AlertMessagesTable;
